import moment from "moment"

export const chart_durations_filters = {
  last_min: {
    text: 'Last minute',
    value: 'last_min',
    realtime: true,
  },
  last_30_min: {
    text: 'Last 30 minutes',
    value: 'last_30_min',
    realtime: true,
  },
  last_hour: {
    text: 'Last Hour',
    value: 'last_hour',
    realtime: true,
  },
  last_2_hour: {
    text: 'Last 2 Hour',
    value: 'last_2_hour',
    realtime: false,
  },
  today: {
    text: 'Today',
    value: 'today',
    realtime: false,
  },
  yesterday: {
    text: 'Yesterday',
    value: 'yesterday',
    realtime: false,
  },
  this_week: {
    text: 'This Week',
    value: 'this_week',
    realtime: false,
  },
  last_week: {
    text: 'Last Week',
    value: 'last_week',
    realtime: false,
  },
  this_month: {
    text: 'This Month',
    value: 'this_month',
    realtime: false,
  },
  last_month: {
    text: 'Last Month',
    value: 'last_month',
    realtime: false,
  },
  last_2_month: {
    text: 'Last 2 Month',
    value: 'last_2_month',
    realtime: false,
  },
  last_3_month: {
    text: 'Last 3 Month',
    value: 'last_3_month',
    realtime: false,
  },
  this_year: {
    text: 'This Year',
    value: 'this_year',
    realtime: false,
  },
  last_year: {
    text: 'Last Year',
    value: 'last_year',
    realtime: false,
  },
  last_2_year: {
    text: 'Last 2 Year',
    value: 'last_2_year',
    realtime: false,
  },
  last_3_year: {
    text: 'Last 3 Year',
    value: 'last_3_year',
    realtime: false,
  },
}